import Vue from 'vue';
import App from './app.vue';
import router from './router';
import { BootstrapVue, FormPlugin, IconsPlugin } from 'bootstrap-vue';
import './styles/styles.scss';
import { addIcons } from './icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import VueGtag from "vue-gtag";

import AOS from 'aos';
import 'aos/dist/aos.css';

import 'bootstrap';

addIcons();

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(FormPlugin);
// Vue.use(VueGtag, {config: { id: "G-KRR9RVWGYX" }});

Vue.config.productionTip = false;

new Vue({
    created() {
        AOS.init({
            // disable: 'mobile',
            duration: 600,
            once: true,
        });
    },
    router,
    render: h => h(App),
}).$mount('#app');
